import {
  createNaturalMultiplicationTask,
  randInt,
  twoDigitByTwoDigitWithZerosExplanation,
} from "./sharedNaturalMultiplication";

function randomTwoDigitNoTrailingZero() {
  let value = randInt(12, 49);
  while (value % 10 === 0) value = randInt(12, 49);
  return value;
}

function pickData() {
  const baseA = randomTwoDigitNoTrailingZero();
  const baseB = randomTwoDigitNoTrailingZero();
  const totalZeros = randInt(2, 4);
  const zerosA = randInt(1, totalZeros - 1);
  const zerosB = totalZeros - zerosA;
  const zeroFactorA = 10 ** zerosA;
  const zeroFactorB = 10 ** zerosB;
  const zeroFactor = zeroFactorA * zeroFactorB;
  const a = baseA * zeroFactorA;
  const b = baseB * zeroFactorB;
  const baseProduct = baseA * baseB;

  return {
    a,
    b,
    baseA,
    baseB,
    baseProduct,
    zeroFactorA,
    zeroFactorB,
    zeroFactor,
    result: baseProduct * zeroFactor,
  };
}

const mod = createNaturalMultiplicationTask({
  type: "NaturalMulTwoDigitByTwoDigitWithZerosTask",
  pickData,
  explain: twoDigitByTwoDigitWithZerosExplanation,
});

export const generateTask = mod.generateTask;
export const renderTask = mod.renderTask;
export const renderInput = mod.renderInput;
export const checkAnswer = mod.checkAnswer;
export const renderAnswer = mod.renderAnswer;
export const renderUserAnswer = mod.renderUserAnswer;
export const renderExplanation = mod.renderExplanation;
